//====================================================
//  Function: Service Create
//====================================================
var counterServices = 1
var serviceResultVisual = $('.js-service-info-result')
var serviceGroup = $('.js-service-group')

function componentServiceCreate() {
  if ($('.js-service-group').length) {
    serviceGroup = $('.js-service-group')

    $(document).on('click', '.js-service-add', function () {
      addNewService()
      addToServicesResultCode()
    })

    $(document).on('click', '.js-service-remove', function () {
      if ($('.js-service-item').length > 1) {
        $(this).closest('.js-service-item').remove()
        addToServicesResultCode()
      }
    })

    $(document).on(
      'keyup',
      '.js-service-input-link, .js-service-input-alt, .js-service-input-src, .js-service-input-title, .js-service-input-btn-text, .js-service-input-perex',
      function () {
        addToServicesResultCode()
      },
    )
  }
}

function addToServicesResultCode() {
  var arrayResultService = []
  var arrayResultServiceString = ''
  var templateBoxHeaderService = `
    <div class="content-wrapper service-block js-service-block services-more-then-two">
			<div class="container">
				<div class="service-group">
  `
  arrayResultService.push(templateBoxHeaderService)

  $('.js-service-item').each(function () {
    var element = $(this)
    var serviceTitle = element.find('.js-service-input-title').val()
    var servicePerex = element.find('.js-service-input-perex').val()
    var serviceBtn = element.find('.js-service-input-btn-text').val()
    var serviceSrc = element.find('.js-service-input-src').val()
    var serviceAlt = element.find('.js-service-input-alt').val()
    var serviceLink = element.find('.js-service-input-link').val()
    if (serviceLink.length == 0) {
      var templateBoxItemService = `
        <div class="service__item">
					<div class="service__content">
						<div class="service__image-block"">
							<img src="${serviceSrc}" alt="${serviceAlt}" title="${serviceAlt}" loading="lazy">
						</div>
						<div class="service__text-block">
							<div class="h3">${serviceTitle}</div>
							<p>${servicePerex}</p>
						</div>
					</div>
				</div>
      `
    } else {
      var templateBoxItemService = `
				<div class="service__item">
					<div class="service__content">
						<a class="service__image-block" href="/${serviceLink}/">
							<img src="${serviceSrc}" alt="${serviceAlt}" title="${serviceAlt}" loading="lazy">
						</a>
						<div class="service__text-block">
							<div class="h3"><a href="/${serviceLink}">${serviceTitle}</a></div>
							<p>${servicePerex}</p>
							<a class="btn btn-secondary btn--min-width-normal" href="/${serviceLink}">${serviceBtn}</a>
						</div>
					</div>
				</div>
      `
    }

    arrayResultService.push(templateBoxItemService)
  })

  var templateBoxFooterService = `
        </div>
      </div>
    </div>
  `

  //  $('.js-service-info-result')[0].outerHTML.replace(/(\r\n|\n|\r)/gm, "");
  arrayResultService.push(templateBoxFooterService)
  arrayResultService = arrayResultService.join(' ')

  serviceResultVisual.empty()
  serviceResultVisual.append(arrayResultService)

  arrayResultServiceString = $(
    '.js-service-info-result .js-service-block',
  )[0].outerHTML.replace(/(\r\n|\n|\r)/gm, '')

  // console.log(arrayResultServiceString)
  // console.log(typeof arrayResultServiceString)
  $('.js-code-result').empty()
  $('.js-code-result').text(arrayResultServiceString)
}

function addNewService() {
  counterServices++
  if ($('html.is-sk').length) {
    var newServiceTemplate = `
				<div class="labels-group__item js-service-item" data-id="${counterServices}">
					<div class="labels-group__content">
							<div class="h--margin-0 margin-bottom-1 margin-bottom-md-2 margin-top-1 h--font-primary-semibold txt-c">
									<h2 class="delta">Služba</h2>
							</div>
							<div class="row gutter-10 margin-bottom-1-2 align-items-center">
									<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
											<label class="form__label form__label--classic" for="service_${counterServices}_title">Titulok</label>
									</div>
									<div class="col-12 col-sm-7 col-xl-8">
											<div class="label__input">
													<input class="form__input form__input--small form__input--outline js-service-input-title" type="text" id="service_${counterServices}_title" name="service_${counterServices}_title" value="Opravíme sklíčka dotykov">
											</div>
									</div>
							</div>
							<div class="row gutter-10 margin-bottom-1-2 align-items-center">
									<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
											<label class="form__label form__label--classic" for="service_${counterServices}_title">Úvodný popis</label>
									</div>
									<div class="col-12 col-sm-7 col-xl-8">
											<div class="label__input">
													<input class="form__input form__input--small form__input--outline js-service-input-perex" type="text" id="service_${counterServices}_title" name="service_${counterServices}_title" value="Vypadol? Spadol na roh? A teraz scrollujete cez pavučinu? Nebláznite - prineste k nám svoj telefón a nechajte si vymeniť sklo na počkanie.">
											</div>
									</div>
							</div>
							<div class="row gutter-10 margin-bottom-1-2 align-items-center">
									<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
											<label class="form__label form__label--classic" for="service_${counterServices}_btn">Text pre tlačítko</label>
									</div>
									<div class="col-12 col-sm-7 col-xl-8">
											<div class="label__input">
													<input class="form__input form__input--small form__input--outline js-service-input-btn-text" type="text" id="service_${counterServices}_btn" name="service_${counterServices}_btn" value="Vďakabohu">
											</div>
									</div>
							</div>
							<div class="row gutter-10 margin-bottom-1-2 align-items-center">
									<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
											<label class="form__label form__label--classic" for="service_${counterServices}_src">Odkaz na obrázok</label>
									</div>
									<div class="col-12 col-sm-7 col-xl-8">
											<div class="label__input">
													<input class="form__input form__input--small form__input--outline js-service-input-src" type="text" id="service_${counterServices}_src" name="service_${counterServices}_src" value="https://cdn.myshoptet.com/usr/apollo.jakubtursky.sk/user/documents/upload/index/oprava-mobilnych-telefonov-1.png">
											</div>
									</div>
							</div>
							<div class="row gutter-10 margin-bottom-1-2 align-items-center">
									<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
											<label class="form__label form__label--classic" for="service_${counterServices}_alt">Popisny text pre obrázok ( nepovinné )</label>
									</div>
									<div class="col-12 col-sm-7 col-xl-8">
											<div class="label__input">
													<input class="form__input form__input--small form__input--outline js-service-input-alt" type="text" id="service_${counterServices}_alt" name="service_${counterServices}_alt" value="Služba text">
											</div>
									</div>
							</div>
							<div class="row gutter-10 margin-bottom-1-2 align-items-center">
									<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
											<label class="form__label form__label--classic" for="service_${counterServices}_link">Odkaz na podstránku ( nepovinné )</label>
									</div>
									<div class="col-12 col-sm-7 col-xl-8">
											<div class="label__input">
													<input class="form__input form__input--small form__input--outline js-service-input-link" type="text" id="service_${counterServices}_link" name="service_${counterServices}_link" value="sluzby/opravime-sklicka-dotykov">
											</div>
									</div>
							</div>
							<div class="row gutter-10 align-items-center margin-top-1 justify-content-end">
									<div class="col-12 txt-r">
											<div class="label__action justify-content-end">
													<div class="label__add js-service-add">
															<svg class="icon-svg icon-plus">
																	<use xlink:href="images/sprites.svg#icon-plus"></use>
															</svg>
															<span>Pridať službu</span>
													</div>
													<div class="label__remove js-service-remove">
															<svg class="icon-svg icon-close">
																	<use xlink:href="images/sprites.svg#icon-close"></use>
															</svg>
															<span>Odobrať službu</span>
													</div>
											</div>
									</div>
							</div>
					</div>
			</div>
			`
  }
  if ($('html.is-hu').length) {
    var newServiceTemplate = `
				<div class="labels-group__item js-service-item" data-id="${counterServices}">
					<div class="labels-group__content">
							<div class="h--margin-0 margin-bottom-1 margin-bottom-md-2 margin-top-1 h--font-primary-semibold txt-c">
									<h2 class="delta">Szolgáltatás</h2>
							</div>
							<div class="row gutter-10 margin-bottom-1-2 align-items-center">
									<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
											<label class="form__label form__label--classic" for="service_${counterServices}_title">Címlapon</label>
									</div>
									<div class="col-12 col-sm-7 col-xl-8">
											<div class="label__input">
													<input class="form__input form__input--small form__input--outline js-service-input-title" type="text" id="service_${counterServices}_title" name="service_${counterServices}_title" value="Megjavítjuk az érintőképernyős csúszdákat">
											</div>
									</div>
							</div>
							<div class="row gutter-10 margin-bottom-1-2 align-items-center">
									<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
											<label class="form__label form__label--classic" for="service_${counterServices}_title">Bevezető leírás</label>
									</div>
									<div class="col-12 col-sm-7 col-xl-8">
											<div class="label__input">
													<input class="form__input form__input--small form__input--outline js-service-input-perex" type="text" id="service_${counterServices}_title" name="service_${counterServices}_title" value="Kiesett? A sarkon esett el? És most egy pókhálót görgetsz? Ne legyen ostoba - hozza el hozzánk a telefonját, és várakozás közben kicseréltetheti az üveget.">
											</div>
									</div>
							</div>
							<div class="row gutter-10 margin-bottom-1-2 align-items-center">
									<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
											<label class="form__label form__label--classic" for="service_${counterServices}_btn">A gomb szövege</label>
									</div>
									<div class="col-12 col-sm-7 col-xl-8">
											<div class="label__input">
													<input class="form__input form__input--small form__input--outline js-service-input-btn-text" type="text" id="service_${counterServices}_btn" name="service_${counterServices}_btn" value="Hála az égnek">
											</div>
									</div>
							</div>
							<div class="row gutter-10 margin-bottom-1-2 align-items-center">
									<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
											<label class="form__label form__label--classic" for="service_${counterServices}_src">Link a képhez</label>
									</div>
									<div class="col-12 col-sm-7 col-xl-8">
											<div class="label__input">
													<input class="form__input form__input--small form__input--outline js-service-input-src" type="text" id="service_${counterServices}_src" name="service_${counterServices}_src" value="https://cdn.myshoptet.com/usr/apollo.jakubtursky.sk/user/documents/upload/index/oprava-mobilnych-telefonov-1.png">
											</div>
									</div>
							</div>
							<div class="row gutter-10 margin-bottom-1-2 align-items-center">
									<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
											<label class="form__label form__label--classic" for="service_${counterServices}_alt">A képhez tartozó leíró szöveg ( opcionális )</label>
									</div>
									<div class="col-12 col-sm-7 col-xl-8">
											<div class="label__input">
													<input class="form__input form__input--small form__input--outline js-service-input-alt" type="text" id="service_${counterServices}_alt" name="service_${counterServices}_alt" value="Szolgáltatás szövege">
											</div>
									</div>
							</div>
							<div class="row gutter-10 margin-bottom-1-2 align-items-center">
									<div class="col-12 col-sm-5 col-xl-4 margin-bottom-05 margin-bottom-xs-0">
											<label class="form__label form__label--classic" for="service_${counterServices}_link">Link az aloldalra ( opcionális )</label>
									</div>
									<div class="col-12 col-sm-7 col-xl-8">
											<div class="label__input">
													<input class="form__input form__input--small form__input--outline js-service-input-link" type="text" id="service_${counterServices}_link" name="service_${counterServices}_link" value="services/repair">
											</div>
									</div>
							</div>
							<div class="row gutter-10 align-items-center margin-top-1 justify-content-end">
									<div class="col-12 txt-r">
											<div class="label__action justify-content-end">
													<div class="label__add js-service-add">
															<svg class="icon-svg icon-plus">
																	<use xlink:href="images/sprites.svg#icon-plus"></use>
															</svg>
															<span>Szolgáltatás hozzáadása</span>
													</div>
													<div class="label__remove js-service-remove">
															<svg class="icon-svg icon-close">
																	<use xlink:href="images/sprites.svg#icon-close"></use>
															</svg>
															<span>Szolgáltatás eltávolítása</span>
													</div>
											</div>
									</div>
							</div>
					</div>
			</div>
			`
  }
  serviceGroup.append(newServiceTemplate)
}
